import { render, staticRenderFns } from "./EditTemplateDetail.vue?vue&type=template&id=70f212f6"
import script from "./EditTemplateDetail.vue?vue&type=script&lang=js"
export * from "./EditTemplateDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports